const validateEmail = (event, setUpFunc) => {
  let target = event.target;
  let validate = true;
  let email = target.value;
  if (email != "") {
    validate = Boolean(
      String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    );
  }
  setUpFunc(validate);
};

const validateEmailString = (email) => {
  return Boolean(
    String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  );
};

const validatePassword = (
  password,
  setupper,
  setlower,
  seteightchar,
  setnumsym
) => {
  if (/[A-Z]/.test(password)) {
    setupper(true);
  } else {
    setupper(false);
  }

  if (/[a-z]/.test(password)) {
    setlower(true);
  } else {
    setlower(false);
  }

  if (password.length >= 8) {
    seteightchar(true);
  } else {
    seteightchar(false);
  }

  if (/[0-9]/.test(password) & /[_!*#]/.test(password)) {
    setnumsym(true);
  } else {
    setnumsym(false);
  }
};

export { validateEmail, validatePassword, validateEmailString };
